import React, { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import TextFieldCustom from "../../../component/elements/textfieldCustom";
import DatePickerCustom from "../../../component/elements/datePicker";
import SelectCustom from "../../../component/elements/selectCustom";
import { pricingTierRule } from "../../../utils/formValidation/validationRules";
import { validateForm } from "../../../utils/formValidation/validation";
import { useSelector } from "react-redux";
import { useSnackbar } from "../../../component/SnackbarContext";
import axiosInstance from "../../../configuration/request";
import { formatDateToDDMMYYYY } from "../../../utils/dateFormat";
import dayjs from "dayjs";
import { validatePricingTier } from "../../../utils/validation";

const statusOption = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const serviceTypeOptions = [
  { value: "WASH_N_FOLD", label: "Wash & Fold" },
  { value: "DRYCLEANING", label: "Dry Cleaning" },
  { value: "TAILORING", label: "Tailoring" },
];


const PricingTierForm = ({ onClose, onSubmit, dialogDetails, mode }) => {
  const [formData, setFormData] = useState({
    minQty: "",
    maxQty: "",
    discount: "",
    startDate: null,
    endDate: null,
    status: "active",
    points: [""],
    serviceType:"WASH_N_FOLD"
  });
  const showSnackbar = useSnackbar();
  const { loginDetails } = useSelector((state) => state.counter);
  const storeId = loginDetails.storeId || null;
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    if (dialogDetails) {
      setFormData({
        points: dialogDetails?.points || [""],
        minQty: dialogDetails?.minQnt || "",
        maxQty: dialogDetails?.maxQnt || "",
        discount: dialogDetails?.discount || "",
        startDate: dayjs(dialogDetails?.startDate) || null,
        endDate: dayjs(dialogDetails?.endDate) || null,
        status: dialogDetails?.status || "",
        serviceType: dialogDetails?.serviceType || "",

      });
    }
  }, [dialogDetails]);



const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setFormErrors((prev) => ({ ...prev, [field]: "" }));
  };


  const handlePointChange = (index, value) => {
    const updatedPoints = [...formData.points];
    updatedPoints[index] = value;
    setFormData((prev) => ({
      ...prev,
      points: updatedPoints,
    }));
    setFormErrors((prev) => ({ ...prev, points: "" }));
  };

  const addPoint = () => {
    setFormData((prev) => ({
      ...prev,
      points: [...prev.points, ""],
    }));
  };

  const removePoint = (index) => {
    const updatedPoints = formData.points.filter((_, i) => i !== index);
    setFormData((prev) => ({
      ...prev,
      points: updatedPoints,
    }));
  };

const handleSubmit = (e) => {
  const fieldErrors = validateForm(formData, pricingTierRule);
  const crossErrors = validatePricingTier(formData);
  setFormErrors(fieldErrors);
  if (Object.keys(crossErrors).length > 0) {
    Object.values(crossErrors).forEach((msg) => {
      showSnackbar(msg, "error");
    });
  }
  if (Object.keys(fieldErrors).length > 0 || Object.keys(crossErrors).length > 0) {
    return; 
  }
  const payload = {
    fromQuantity: Number(formData.minQty),
    toQuantity: Number(formData.maxQty),
    status: formData.status,
    discount: Number(formData.discount),
    startDate: formatDateToDDMMYYYY(formData.startDate),
    endDate: formatDateToDDMMYYYY(formData.endDate),
    // features: formData.points,
    serviceType:formData.serviceType
  };

  // send API request
  const request = mode === "create"
    ? axiosInstance.post(`/customer/store/pricing-tiers/create/${storeId}`, payload)
    : axiosInstance.patch(`/customer/store/pricing-tiers/update/${dialogDetails.id}`, payload);

  request
    .then(() => onSubmit())
    .catch((error) => {
      showSnackbar(
        error?.response?.data?.message || "Something went wrong!",
        "error"
      );
    });
};

  return (
    <div className="pt-6 px-4">
      <div className="flex justify-between mb-6">
        <div className="flex justify-center w-full text-xl font-[500]">
          Create Discount Card
        </div>
        <button
          onClick={onClose}
          className="text-gray-600 hover:text-black"
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="flex flex-col gap-4 w-full px-8">
        <div className="grid  grid-cols-1 md:grid-cols-2 gap-y-0 gap-x-6">
          <div className="w-full">
            <div className="text-sm font-medium text-gray-700 mb-1">
              Service Type*
            </div>
              <SelectCustom
               placeholder="Select service type"
            options={serviceTypeOptions}
            value={formData.serviceType}
            onChange={(e) => handleChange("serviceType",e.target.value)}
            error={!!formErrors.serviceType}
            helperText={formErrors.serviceType || " "}
          />
          </div>
          <div className="w-full">
            <div className="text-sm font-medium text-gray-700 mb-1">
             {formData?.serviceType === "WASH_N_FOLD" ? "Min lbs" : "Min Quantity"}
            </div>
            <TextFieldCustom
              placeholder="e.g., 1"
              value={formData.minQty}
                onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*\.?\d{0,2}$/.test(val))
                        handleChange("minQty", e.target.value);
                    }}
              fullWidth
              error={!!formErrors.minQty}
              helperText={formErrors.minQty || " "}
            />
          </div>
          <div className="w-full">
            <div className="text-sm font-medium text-gray-700 mb-1">
              {formData?.serviceType === "WASH_N_FOLD" ? "Max lbs" : "Max Quantity"}
            </div>
            <TextFieldCustom
              placeholder="e.g., 5"
              value={formData.maxQty}
                  onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*\.?\d{0,2}$/.test(val))
                        handleChange("maxQty", e.target.value);
                      }}
              fullWidth
              error={!!formErrors.maxQty}
              helperText={formErrors.maxQty || " "}
            />
          </div>

          <div className="w-full">
            <div className="text-sm font-medium text-gray-700 mb-1">
              Discount (%)
            </div>
            <TextFieldCustom
              placeholder="e.g., 10%"
              value={formData.discount}
              onChange={(e) => {
                const val = e.target.value;
                if (/^\d*\.?\d{0,2}$/.test(val)) handleChange("discount", val);
              }}
              fullWidth
              error={!!formErrors.discount}
              helperText={formErrors.discount || " "}
            />
          </div>
          {/* Status */}
          <div className="w-full">
            <div className="text-sm font-medium text-gray-700 mb-1">Status</div>
            <SelectCustom
              placeholder="Select Status"
              value={formData.status}
              onChange={(e) => handleChange("status", e.target.value)}
              options={statusOption}
              error={!!formErrors.status}
              helperText={formErrors.status || " "}
            />
          </div>

          <div className="flex-1">
            <div className="text-sm font-medium text-gray-700 mb-2">
              Start Date
            </div>
            <DatePickerCustom
              value={formData.startDate}
              onChange={(date) => handleChange("startDate", date)}
              error={!!formErrors.startDate}
              helperText={formErrors.startDate || " "}
              minDate={dayjs()}
            />
          </div>
          <div className="flex-1">
            <div className="text-sm font-medium text-gray-700 mb-2">
              End Date
            </div>
            <DatePickerCustom
              value={formData.endDate}
              onChange={(date) => handleChange("endDate", date)}
              error={!!formErrors.endDate}
              helperText={formErrors.endDate || " "}
              minDate={dayjs()}
            />
          </div>
        </div>
        {/* <div>
          <div className="text-sm font-medium text-gray-700">
            Benefits / Points
          </div>

          {formData.points.map((point, index) => (
            <div key={index} className="flex items-center gap-2 mt-2">
              <TextFieldCustom
                placeholder={`Point ${index + 1}`}
                value={point}
                onChange={(e) => handlePointChange(index, e.target.value)}
                fullWidth
              />
              {formData.points.length > 1 && (
                <button
                  type="button"
                  onClick={() => removePoint(index)}
                  className="text-red-600"
                >
                  <DeleteIcon fontSize="small" />
                </button>
              )}
            </div>
          ))}
          {formErrors.points && (
            <div className="text-xs text-[#d32f2f] mt-1">
              {formErrors.points}
            </div>
          )}
          <button
            type="button"
            onClick={addPoint}
            className="mt-2 text-[#3587B8] flex items-center text-sm"
          >
            <AddIcon fontSize="small" />{" "}
            <span className="ml-1">Add another point</span>
          </button>
        </div> */}

        {/* Submit */}
        <div className="flex justify-center items-center mb-6">
          <CustomButton
            onClick={handleSubmit}
            customeClass="gradient-button w-[160px] h-[40px]"
          >
            {mode === "create" ? "Create Tier" : "Update Tier"}
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default PricingTierForm;
